import { type LabelType } from './image-label.react';
import { type AnnotationT } from './labelling';
export { default as ImageLabel } from './image-label.react';
export type { Label, BoundingBoxTool, ImageMetadata } from './image-label.react';
export type OutputLabel = {
  type: LabelType;
  categoryName: string;
  toolIndex: number;
  meta: {
    x: number;
    y: number;
    width: number;
    height: number;
    drawMode?: LabelType;
    annotationType: 'V1';
  } | AnnotationT;
  max?: number;
  isRequired?: boolean;
};
export type { OutputAnnotationT as ImageAnnotationT, OutputLabelledDataT, OutputLabellingValidationsT as LabellingValidationsT, onStoreChangeT, ImageOutputLabelledDataT, VideoOutputLabelledDataT, PDFOutputLabelledDataT, InputFrameT, OutputFrameT, OutputAnnotationT } from './labelling';
export type { AnnotationLabelT } from '../common/types/types';
export type { BoundingBoxTrackingOutputT, BoundingBoxTrackingInputT } from './types';
export { LABELLING_TYPE } from '../common/constant/constant';